import React, { useState, useRef } from "react";
import "./contentpage.css";
import LandingSection from "./LandingSection";

import Question from "../components/Question";
import BoxWithShadow from "../components/BoxWithShadow";
import FloatingPageNav from "../components/FloatingPageNav";

function IslamicTradePage2() {
 const contentRef = useRef(null);
    const titleText = "Conditions of a Permissible Trade (shuroot al bay') ";
  
     const links = {
    prev: "/islamic-trade-page-1", 
    index: "/index",                 
    next: "/islamic-trade-page-3", 
  };
   const questions = [
    {
      text: "1. What is a fundamental condition for a valid trade in Islam?",
      options: [
        { value: "A", label: "A. The presence of a witness" },
        { value: "B", label: "B. Mutual consent of buyer and seller" },
        { value: "C", label: "C. The transaction must occur in a marketplace." },
        { value: "D", label: "D. The buyer must pay in gold" },
      ],
      correct: "B",
    },
    {
      text: "2. Which of the following is an example of an invalid trade due to the lack of legal capacity?",
      options: [
        { value: "A", label: "A. A minor buying a snack from a store with their parent's permission" },
        { value: "B", label: "B. A mentally incapacitated person selling their property independently" },
        { value: "C", label: "C. A salesperson selling goods on behalf of the owner" },
        { value: "D", label: "D. A person buying a car with a loan" },
      ],
      correct: "B",
    },
    {
      text: "3. Why does Islam prohibit selling goods that the seller cannot deliver?",
      options: [
        { value: "A", label: "A. Because it increases the price of goods artificially" },
        { value: "B", label: "B. Because it creates uncertainty (gharar), which leads to deception and disputes" },
        { value: "C", label: "C. Because it benefits the seller more than the buyer" },
        { value: "D", label: "D. Because it is only allowed in physical marketplaces" },
      ],
      correct: "B",
    },
    {
      text: "4. According to Islamic Law, when is it permissible to sell a dog?",
      options: [
        { value: "A", label: "A. When it is trained for hunting or security purposes" },
        { value: "B", label: "B. When it is sold in a foreign country" },
        { value: "C", label: "C. When it is kept as a household pet" },
        { value: "D", label: "D. When the buyer agrees to donate part of the profit to charity" },
      ],
      correct: "A",
    },
  ];

    // State to track selected answers for all questions
  const [answers, setAnswers] = useState({});

  // Function to update an answer
  const handleAnswerChange = (questionIndex, selectedValue) => {
    setAnswers((prev) => ({ ...prev, [questionIndex]: selectedValue }));
  };

  // Compute score
  const score = questions.reduce((total, q, index) => {
    return total + (answers[index] === q.correct ? 1 : 0);
  }, 0);

  return (
    <div className="container">
      <LandingSection
           titleText={titleText}
           scrollToRef={contentRef}
           progressValue={2}
           timerMinutes={60}
           currentLevel={1}
         />
     
      <p className="content" ref={contentRef}>
       
       <br/>
       Welcome to  <b>Day 2</b>!  Today, we move
        deeper into the foundational aspects of trade in Islam. After
        understanding the significance of trade, it's definition and guidelines pertaining it in the 
        previous session, we now explore the specific conditions that make a
        trade permissible under Islamic law. Just as acts of worship require
        conditions for validity, so too do business transactions. Today’s
        session will equip you with the knowledge to identify and uphold the
        essential requirements for lawful, ethical trade that pleases Allah and
        protects the rights of all parties involved.
        <br />
        <br />
        In Islam, every act of worship requires specific conditions to be met
        before it is considered valid. Whether it is prayer, fasting, or
        charity, fulfilling these conditions ensures sincerity, correctness, and
        acceptance by Allah. Just as prayer requires purification and correct
        timing, business transactions also have essential conditions that must
        be met for them to be lawful and ethical. Buying and selling in Islam is
        not merely a worldly pursuit but an act of worship when conducted with
        honesty, fairness, and adherence to sacred principles. A trade that is
        executed with transparency, mutual consent, and fairness aligns with
        Islamic teachings and earns blessings from Allah. Conversely, failing to
        meet these conditions can lead to injustice, exploitation, and even sin.
        Therefore, just as one ensures their worship is performed correctly, it
        is equally important to ensure that trade transactions meet all
        necessary conditions before execution, making them a means of both
        lawful earnings and spiritual reward.
        <br/><br/>
         Scholars stipulate the following conditions after exhaustive research and study of the evidences in the sources of Islamic Law i.e the Qur'an and the Sunnah as per the understanding of the early Muslims and the consensus(Ijma) of the Muslims.<br/><br/>
      </p>
      
       
 <table className="trade-table" border="1">
  <thead>
    <tr>
      <th>Conditions of a valid trade in Islam</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>Mutual Consent of Buyer and Seller</td>
    </tr>
    <tr>
      <td>Legal Capacity of Buyer and Seller</td>
    </tr>
    <tr>
      <td>Permissibility to Benefit from Goods and Services</td>
    </tr>
    <tr>
      <td>Trade by Owner or Authorized Representative</td>
    </tr>
    <tr>
      <td>Ability to Deliver Goods or Services</td>
    </tr>
    <tr>
      <td>Knowledge of Goods and Services</td>
    </tr>
    <tr>
      <td>Knowledge of the Price</td>
    </tr>
  </tbody>
</table>

<br/><br/>

<p className="content">Let us understand them in detail.<br/><br/>
        <b> 1) Mutual Consent of Buyer and Seller </b> <br />
        <br />
        Mutual consent is the cornerstone of any valid trade in Islam. Both the
        buyer and seller must willingly agree to the terms of the transaction
        without coercion, manipulation, or deception. This principle ensures
        fairness and protects the rights of both parties.
        <br />
        Allah explicitly emphasizes mutual consent in trade:
        <br /> “O you who have believed, do not consume one another’s wealth
        unjustly but only [in lawful] business by mutual consent.”{" "}
        <i>
          <a href="https://quran.com/4/29" target="blank">
            {" "}
            (Surah An-Nisa, 4:29)
          </a>
        </i>
        <br />
        The Prophet Muhammad (peace be upon him) reinforced this principle:
        <br /> “A sale is valid only if both parties give their consent.”{" "}
        <i>
          <a href="https://sunnah.com/ibnmajah:2185" target="blank">
            (Sunan Ibn Majah, Hadith 2185)
          </a>
        </i>
        <br />
        A trade must not involve coercion or undue pressure. For example, if a
        person is forced to sell their property under threat, the sale is void.
        However, in cases of legal obligation, such as debt repayment, a court
        may compel a buyer to return goods to the rightful owner.
        <br />
        Mutual consent must be free from deceit or misrepresentation. If a buyer
        agrees to purchase a car believing it to be brand new, but later finds
        it to be used, the contract can be voided due to fraud.
        <br />
        Example of a valid trade : A buyer and seller negotiate the price of a
        car and reach a mutual agreement without any external pressure.
        <br />
        Example of an invalid Trade: A person is forced to sell their house at a
        low price due to threats. Such a transaction is considered unjust and
        void in Islamic law.
        <br />
        <br />
        <b>2) Legal Capacity of Buyer and Seller</b> <br />
        <br />
        Both the buyer and seller must have the legal capacity to engage in
        trade. This includes being of sound mind, of legal age, and having the
        freedom to transact. Children, mentally incapacitated individuals, and
        slaves are not permitted to engage in trade
        independently.
        <br />
        Allah instructs guardians to protect the wealth of those who lack
        capacity:
        <br /> “Do not give the weak-minded your property, which Allah has made
        a means of sustenance for you, but provide for them with it and clothe
        them and speak to them words of kindness.”
        <i>
          <a href="https://quran.com/4/5" target="blank">
            (Surah An-Nisa, 4:5)
          </a>
        </i>
        <br />
        The Prophetic Hadith states <br />
        “The pen is lifted from three: the insane until he regains sanity, the
        sleeper until he wakes up, and the child until he reaches puberty.”
        <i>
          <a href="https://sunnah.com/nasai:3432" target="blank">
            {" "}
            (Sunan Abu Dawood, Hadith 4398)
          </a>
        </i>
        <br />
        While minors are generally not allowed to engage in significant trade,
        they may conduct small transactions customary in society, such as buying
        snacks or school supplies, with parental approval. If a child is
        entrusted with money to purchase goods and does so without deception,
        the transaction is valid.
        <br />
        Example of a valid Trade: A 10 year old buys a toy with money given by
        their parents.
        <br />
        Example of an Invalid Trade: A mentally incapacitated individual sells
        property without supervision.
        <br />
        <br />
        <b>3) Permissibility to Benefit from Goods and Services</b> <br />
        <br />
        The goods or services involved in the trade must be halal (permissible)
        according to Islamic law. Items that are haram (forbidden), such as
        alcohol, pork, and anything harmful or unethical, cannot be traded.
        However, there are exceptions for necessities, such as owning a dog for
        protection or hunting.
        <br />
        Allah says in the Qur'an <br />
        “O you who have believed, eat from the good things which We have
        provided for you and be grateful to Allah if it is [indeed] Him that you
        worship.”{" "}
        <i>
          <a href="https://quran.com/2/172" target="blank">
            (Surah Al-Baqarah, 2:172)
          </a>
        </i>
        <br />
        The Prophetic Hadith states <br />
        “The Messenger of Allah forbade the price of a dog, except for a hunting
        dog.”
        <i>
          <a href="https://sunnah.com/ibnmajah:2185" target="blank">
            (Sahih Muslim, Hadith 1569)
          </a>
        </i>
        <br />
        Transactions must be free from unethical exploitation. For instance,
        selling items that have no real value or are intended to deceive buyers
        is impermissible. Islamic ethics also prohibit hoarding essential goods
        to artificially inflate prices.
        <br />
        Example of a Valid Trade: Selling a trained guard dog for security
        purposes.
        <br />
        Example of an Invalid Trade: Selling alcohol or gambling services, as
        they are explicitly prohibited in Islam.
        <br />
        <br />
        <b>4) Trade by Owner or Authorized Representative</b> <br />
        <br />
        Only the owner of the goods or an authorized representative, such as a
        guardian, agent, or trustee, has the right to conduct a trade. Selling
        someone else’s property without permission is not only invalid but also
        constitutes theft or fraud, which is strictly prohibited in Islam.
        Ownership and authorization ensure fairness in transactions and prevents
        disputes that arise from unauthorized sales. Islam places great emphasis
        on the sanctity of property rights, ensuring that no individual can take
        advantage of another’s possessions without explicit consent. This
        principle safeguards personal and commercial dealings from deception and
        injustice.
        <br />
        The teachings of the Prophet Muhammad (peace be upon him) emphasize this
        principle, as he stated, <br />
        “A sale is not valid unless it is by the owner or one authorized by
        him.”{" "}
        <i>
          <a href="https://sunnah.com/tirmidhi:1239" target="blank">
            {" "}
            (Sunan Al-Tirmidhi, Hadith 1239)
          </a>
        </i>
        <br />
        This hadith reinforces the idea that any transaction lacking proper
        ownership or authorization is inherently flawed and legally void.
        <br />
        Example of a valid transaction: A salesperson sells items on behalf of
        the store owner, acting as a legitimate representative. <br />
        Example of an invalid Trade: A person attempting to sell a neighbor’s
        car without their knowledge or permission, which would be both unlawful
        and unethical.
        <br />
        <br />
        <b>5) Ability to Deliver Goods or Services</b>
        <br />
        <br />
        The ability to deliver goods or services is another essential condition
        of a valid trade. A seller must be capable of providing the product or
        service they are offering. Selling items that are lost, non-existent, or
        impossible to deliver creates uncertainty, known as <i>gharar</i>, which
        Islam prohibits due to its potential to lead to deception and disputes.
        A transaction involving uncertainty leaves one party vulnerable to loss,
        and this is contrary to the principles of fairness and transparency that
        Islam upholds in commercial dealings.
        <br />
        The Prophet Muhammad (peace be upon him) warned against such
        transactions, stating, <br />
        “Do not sell what you do not possess.”{" "}
        <e>
          <a href="https://sunnah.com/abudawud:3503" target="blank">
            {" "}
            (Sunan Abu Dawood, Hadith 3503){" "}
          </a>
        </e>
        <br />
        This hadith serves as a reminder that sellers should have full control
        and ownership of the goods they are trading. An example of a valid sale
        would be selling a car that is physically present or one that will be
        delivered on a specified date with a clear agreement. On the other hand,
        it would be an invalid to sell a car that has been lost, stolen, or
        otherwise unavailable for delivery, as such a transaction misleads the
        buyer and creates an unfair financial risk.
        <br />
        <br />
        <b>6) Knowledge of Goods and Services</b>
        <br />
        <br />
        Both the buyer and the seller must have clear and accurate knowledge of
        the goods or services being exchanged. This knowledge can be obtained
        through physical inspection, a detailed description, or any other means
        that provide clarity. If a trade is conducted with ambiguity, deception,
        or misrepresentation, it becomes invalid. Transparency is a fundamental
        requirement in business transactions, as it ensures that all parties
        make informed decisions without being misled. Without clear knowledge,
        buyers may unknowingly purchase defective, inferior, or entirely
        different goods than what they expected. The Prophet Muhammad (peace be
        upon him) strongly condemned deceit in trade, stating, <br />
        “Whoever deceives us is not one of us.”{" "}
        <e>
          <a href="https://sunnah.com/muslim:102" target="blank">
            (Sahih Muslim, Hadith 102){" "}
          </a>
        </e>
        <br />
        This hadith underscores the seriousness of dishonesty in business and
        warns against fraudulent practices. An example of a valid trade is when
        a buyer inspects a sample of dates before purchasing a larger quantity,
        ensuring that they are satisfied with the quality. In contrast, an
        invalid trade would be selling a box of unspecified items without
        allowing the buyer to inspect or know its contents, as this creates
        uncertainty and potential disappointment.
        <br />
        <br />
        <b>7) Knowledge of the Price</b>
        <br />
        <br />
        The price of goods or services must be known and explicitly agreed upon
        by both parties before the transaction takes place. Any ambiguity in
        pricing can lead to disputes and is strictly prohibited in Islam. A fair
        and transparent pricing system is necessary to maintain trust and
        prevent exploitation in business dealings. When prices are hidden or
        manipulated, one party may feel cheated or coerced into paying more than
        they initially agreed upon. This lack of clarity is unjust and goes
        against the ethical principles of Islamic trade.
        <br />
        The Qur’an provides clear guidance on this matter, stating, <br />
        “And give full measure when you measure, and weigh with an even
        balance.”
        <e>
          <a href="https://quran.com/17/35" target="blank">
            (Surah Al-Isra, 17:35){" "}
          </a>
        </e>{" "}
        <br />
        This verse emphasizes the importance of honesty in transactions,
        ensuring that sellers do not take advantage of buyers through hidden
        fees or misleading pricing structures. An example of a valid sale would
        be a seller and buyer agreeing on a set price for a car, with the buyer
        paying the agreed amount in full without any hidden charges. However, an
        invalid trade would occur if a seller imposed additional undisclosed
        fees after the transaction, leaving the buyer unaware and unfairly
        obligated to pay more than initially agreed. This type of deceit is not
        only unethical but also violates Islamic principles of fairness in
        commerce.
        <br />
        <br />
        Islamic trade principles emphasize fairness, transparency, and mutual
        consent, ensuring that all transactions benefit both parties and avoid
        exploitation. By adhering to these conditions, Muslims can engage in
        ethical commerce that aligns with their faith. Trade, when conducted
        within these boundaries, not only fulfills worldly needs but also earns
        the pleasure of Allah and contributes to a just and equitable society.
        Additionally, ethical business conduct fosters trust and prosperity in a
        community, strengthening economic stability and social well-being.
        <br />
        <br />
          <BoxWithShadow>
                  <strong>IMPORTANT</strong>
                  <br />
                  Islamic scholars distinguish between conditions (shuroot) and pillars (arkan) in an act of worship. If a Muslim buys and sells with the intention of attaining the pleasure of Allah, then his act of completing a sale is deemed as worship. Conditions in any act of worship precede the act itself. As you might have observed, all seven conditions that we studied above precede the act of actual sale, while pillars of an act of worship are executed during the act of the worship and not before it.
                  <br />
                </BoxWithShadow>
        <b>Summary of Today's Lesson</b>
        <br />
        <br />
        Today we explored the seven foundational conditions that make trade both valid and ethical under Islamic principles. The lesson emphasized that trade is not merely a worldly transaction but can be an act of worship when conducted with integrity, fairness, and transparency. Mutual consent between the buyer and seller ensures that neither party is coerced, deceived, or pressured, protecting the rights and dignity of all involved. Legal capacity requires that participants be of sound mind and of age, ensuring responsibility and accountability in financial dealings. Only goods and services that are permissible (halal) may be traded, preventing harm and promoting ethical commerce. Trades must be conducted by the owner or an authorized representative, maintaining the sanctity of property rights. The seller must have the ability to deliver the goods or services, avoiding uncertainty (gharar) that could lead to disputes. Both parties must possess clear knowledge of the goods or services being exchanged and the exact price, eliminating ambiguity and fostering trust. Together, these conditions create a framework that upholds justice, transparency, and ethical conduct, ensuring that trade benefits both parties and aligns with Islamic teachings. By observing these principles, Muslims can engage in commerce that not only satisfies worldly needs but also earns the pleasure of Allah, strengthens social cohesion, and promotes a fair and prosperous community.<br/><br/>
        <b> Coming Up Next</b>
        <br />
        <br />
        On Day Three, we will explore the Terms of Trade in Islam, where we
        will discuss how contractual terms are formed, what makes them valid or
        void, and how to ensure that both parties’ rights and duties are upheld
        throughout the trade process. This will build upon today's session and
        bring us closer to understanding the structure of an ideal Islamic
        contract.
      </p>{" "}
      {/* Properly closing the <p> tag */}
      <h2>Test your understanding</h2>
      {questions.map((q, index) => (
      <Question
        key={index}
        questionText={q.text}
        options={q.options}
        correctAnswer={q.correct}
        onAnswer={(value) => handleAnswerChange(index, value)} // pass parent handler
      />
    ))}
    
           <div style={{ marginTop: "20px", fontWeight: "bold", fontSize: "1.2em" }}>
            Score: {score} / {questions.length}
          </div>
      
      
       <FloatingPageNav 
              prevLink={links.prev} 
              indexLink={links.index} 
              nextLink={links.next} 
            />
    </div>
  );
}

export default IslamicTradePage2;
